import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { EngineeringSystems, EngineeringSystemsTypes } from 'landings/engineering-systems';
import { RemoteProps } from './widgets-types';

type EngineeringSystemsRemoteProps = {
  system: EngineeringSystemsTypes;
} & RemoteProps;

export const EngineeringSystemsRemote: React.FC<EngineeringSystemsRemoteProps> = ({
  router,
  store,
  system,
}) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <EngineeringSystems system={system} />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
